import { Icon, Tag, Tooltip } from '@chakra-ui/react';
import { HiCheck, HiXMark } from 'react-icons/hi2';

type Props = {
  isMatch: boolean;
  help: string;
};

export const MatchTag = ({ isMatch, help }: Props) => (
  <Tooltip label={help}>
    <Tag size="sm" colorScheme={isMatch ? 'green' : 'red'}>
      <Icon as={isMatch ? HiCheck : HiXMark} />
    </Tag>
  </Tooltip>
);
